module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-driver-subscription-slots"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.availableSlots), function(slot, index) {
    return _c('div', {
      staticClass: "columns driver-slot small-2"
    }, [_c('div', {
      staticClass: "inner-content"
    }, [_c('dropdown', [_c('img', {
      staticClass: "driver-image",
      attrs: {
        "slot": "placeholder",
        "src": slot.profile_picture
      },
      slot: "placeholder"
    }), (slot.available) ? _c('div', {
      staticClass: "unselect"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "columns small-9"
    }, [(_vm.selectizeDrivers) ? _c('selectize-driver', {
      attrs: {
        "clientDrivers": _vm.selectizeDrivers
      },
      on: {
        "optionSelected": _vm.setDriverId
      }
    }) : _vm._e()], 1), _c('div', {
      staticClass: "columns small-2"
    }, [_c('input', {
      staticClass: "button small",
      attrs: {
        "type": "submit",
        "value": "Add"
      },
      on: {
        "click": function($event) {
          return _vm.addDriver(index)
        }
      }
    })])])]) : _c('div', {
      staticClass: "select"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removeDriver(index)
        }
      }
    }, [_vm._v("Remove from subscription")])])]), _vm._v(_vm._s(slot.name) + " " + _vm._s(slot.surname))], 1)])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24ed8ab6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/DriverSubscriptionSlots.vue
// module id = 2348
// module chunks = 1